import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { gql } from '@apollo/client/core';
import { getToken } from '@nitra/components/njs/token.js';
import jwtDecode from '@nitra/jwt-decode';
import { apolloClient } from './apollo.js';
export let roles;
export const user = jwtDecode(getToken());
const consola = createLogger(__filename);

// ініціалізуємо Vuex та roles для Casl
export default async ({
  store
}) => {
  var _response$data$user, _response$data$user2, _response$data$user3, _response$data$user4, _response$data$user5, _response$data$user5$, _response$data$user6, _response$data$user6$, _response$data$user7, _response$data$user8, _response$data$user9, _response$data$user0, _response$data$user1, _response$data$user10, _response$data$user11, _response$data$user12;
  if (!apolloClient) {
    consola.debug('Skip UserData boot');
    return;
  }
  consola.debug('Start UserData boot');

  // Дані по користувачу
  const response = await apolloClient.query({
    query: gql`
      query user($email: String!) {
        user: user_by_pk(email: $email) {
          name
          email_from
          email_from_name
          operator_number
          operator_number2
          info
          signature
          pos_ts
          groups {
            group_id
            group {
              email_from
              email_from_name
            }
          }
          org_structure {
            id
            name
            hierlevel
          }
          user_role {
            permissions
          }
        }
        provider: get_provider {
          id
          name
          org_structure {
            name
            path
          }
        }
      }
    `,
    variables: {
      email: user['https://hasura.io/jwt/claims']['x-hasura-user-id']
    }
  });

  // Разрешенные провайдеры пользователя + данные по Т3 провайдера
  const providers = {};
  if (response.data.provider) {
    for (const p of response.data.provider) {
      var _p$org_structure$name, _p$org_structure, _p$org_structure$path, _p$org_structure2;
      providers[p.id] = {
        id: p.id,
        name: p.name,
        t3: (_p$org_structure$name = (_p$org_structure = p.org_structure) === null || _p$org_structure === void 0 ? void 0 : _p$org_structure.name) !== null && _p$org_structure$name !== void 0 ? _p$org_structure$name : null,
        t3Path: (_p$org_structure$path = (_p$org_structure2 = p.org_structure) === null || _p$org_structure2 === void 0 ? void 0 : _p$org_structure2.path) !== null && _p$org_structure$path !== void 0 ? _p$org_structure$path : null
      };
    }
  }

  // Save user data
  store.commit('session/setUserData', {
    user: {
      id: user['https://hasura.io/jwt/claims']['x-hasura-user-id'],
      name: (_response$data$user = response.data.user) === null || _response$data$user === void 0 ? void 0 : _response$data$user.name,
      emailFrom: ((_response$data$user2 = response.data.user) === null || _response$data$user2 === void 0 ? void 0 : _response$data$user2.email_from) || user['https://hasura.io/jwt/claims']['x-hasura-user-id'],
      emailFromName: (_response$data$user3 = response.data.user) === null || _response$data$user3 === void 0 ? void 0 : _response$data$user3.email_from_name,
      groups: (_response$data$user4 = response.data.user) === null || _response$data$user4 === void 0 ? void 0 : _response$data$user4.groups,
      org_structure_id: ((_response$data$user5 = response.data.user) === null || _response$data$user5 === void 0 ? void 0 : (_response$data$user5$ = _response$data$user5.org_structure) === null || _response$data$user5$ === void 0 ? void 0 : _response$data$user5$.id) || null,
      org_structure_name: ((_response$data$user6 = response.data.user) === null || _response$data$user6 === void 0 ? void 0 : (_response$data$user6$ = _response$data$user6.org_structure) === null || _response$data$user6$ === void 0 ? void 0 : _response$data$user6$.name) || null
    },
    operator: (_response$data$user7 = response.data.user) === null || _response$data$user7 === void 0 ? void 0 : _response$data$user7.operator_number,
    operator2: (_response$data$user8 = response.data.user) === null || _response$data$user8 === void 0 ? void 0 : _response$data$user8.operator_number2,
    signature: (_response$data$user9 = response.data.user) === null || _response$data$user9 === void 0 ? void 0 : _response$data$user9.signature,
    groups: (_response$data$user0 = response.data.user) === null || _response$data$user0 === void 0 ? void 0 : _response$data$user0.groups.map(g => g.group_id),
    orgStructure: (_response$data$user1 = response.data.user) === null || _response$data$user1 === void 0 ? void 0 : _response$data$user1.org_structure,
    providers,
    ts: ((_response$data$user10 = response.data.user) === null || _response$data$user10 === void 0 ? void 0 : _response$data$user10.pos_ts) || []
  });

  // Фильтры по умолчанию для пользователя
  // назначено на пользователя
  // if (
  //   !store.state.persist.filter.assigned_user.length ||
  //   !store.state.persist.filter.assigned_group.length
  // ) {
  store.commit('persist/setFilter', {
    key: 'assigned_user',
    value: [user['https://hasura.io/jwt/claims']['x-hasura-user-id']]
  });
  // }
  // закрытые задачи
  // if (!store.state.persist.filter.is_completed.length) {
  store.commit('persist/setFilter', {
    key: 'is_completed',
    value: ['false']
  });
  // }

  // провайдер
  const p = store.state.persist.provider;
  if (!p || !providers[p]) {
    var _response$data$provid, _response$data$provid2;
    store.commit('persist/setProvider', (_response$data$provid = (_response$data$provid2 = response.data.provider[0]) === null || _response$data$provid2 === void 0 ? void 0 : _response$data$provid2.id) !== null && _response$data$provid !== void 0 ? _response$data$provid : null);
  }

  // Для Casl
  roles = [];
  if ((_response$data$user11 = response.data.user) !== null && _response$data$user11 !== void 0 && _response$data$user11.user_role) {
    var _response$data$user$u;
    roles = (_response$data$user$u = response.data.user.user_role) === null || _response$data$user$u === void 0 ? void 0 : _response$data$user$u.permissions;
  }

  // ДАННЫЕ ПО СТАТУСАМ ОПЕРАТОРОВ
  const res = await apolloClient.query({
    query: gql`
      query operator_status_enum {
        operator_status_enum {
          name
          data
        }
      }
    `
  });
  const status = {};
  for (const s of res.data.operator_status_enum) {
    const data = JSON.parse(s.data);
    status[s.name] = {
      name: s.name || 'offline',
      title: data.title || '',
      color: data.color || 'grey',
      colorCode: data.color_code || '#607d8b',
      icon: data.icon || 'star',
      order: data.sort_order || 100,
      role: data.role || []
    };
  }
  store.commit('session/setStatus', status);

  // Временно!!!!!
  // const po = ['left', 'right']
  // if (po.includes(store.state.persist.osDirection)) {
  store.commit('persist/setOsPosition', [8, 8]);
  store.commit('persist/setOsDirection', 'up');
  // }

  user.operatorNumber = (_response$data$user12 = response.data.user) === null || _response$data$user12 === void 0 ? void 0 : _response$data$user12.operator_number;
  consola.debug('End userData boot');
};